<template>
  <div class="joinTeam">
    <div class="inviter" v-if="myStarTeamInfo.joinTeamFlag">
      <div class="photo"><img :src="myStarTeamInfo.avatar ? myStarTeamInfo.avatar : picUrl.defaultImage"></div>
      <div class="name">我已加入“{{myStarTeamInfo.teamName}}”战队</div>
    </div>
    <div class="inviter" v-else>
      <div class="photo"><img :src="inviterAvatar ? inviterAvatar : picUrl.defaultImage"></div>
      <div class="name">{{inviterName}}邀请您加入“{{teamName}}”战队</div>
    </div>
    <div class="joinTeamForm">
      <div class="banner">
        <router-link :to="{path: '/', query: {saleOrgNo: joinTeamSourceNo, saleOrgType: joinTeamSourceType, activityId: joinTeamActivityId}}">
          <img :src="banner ? banner : picUrl.defaultImage">
          <div class="tip">查看活动页面</div>
        </router-link>
      </div>
      <div class="weui-cells weui-cells_form" v-if="!myStarTeamInfo.joinTeamFlag">
        <div class="weui-cell">
          <div class="weui-cell__hd"><label class="weui-label">姓名</label></div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" maxlength="20" placeholder="请输入您的姓名" :disabled="myStarTeamInfo.realName" v-model="formData.name" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd"><label class="weui-label">手机号</label></div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" pattern="[0-9]*" maxlength="11" placeholder="请输入您的手机号" :disabled="myStarTeamInfo.mobile" v-model="formData.mobile" />
          </div>
        </div>
        <div class="weui-cell" v-if="!myStarTeamInfo.mobile">
          <div class="weui-cell__hd"><label class="weui-label">验证码</label></div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" pattern="[0-9]*" maxlength="6" v-model="formData.captcha" placeholder="请输入验证码" />
          </div>
          <div class="weui-cell__ft">
            <button type="button" class="weui-btn weui-btn_default weui-vcode-btn" :disabled="sendLock" style="width: 100px;padding: 0;margin: 0;" @click="checkMsg">{{!sendLock ? '获取验证码' : countDown + '秒后重试'}}</button>
          </div>
        </div>
        <div class="weui-form__opr-area">
          <a class="weui-btn weui-btn_primary btn-join" href="javascript:" @click="joinTeam">立即加入</a>
        </div>
      </div>
      <router-link v-else class="weui-btn weui-btn_primary btn-join" style="width: 100%; margin-top: 20px;" :to="{path: '/', query: {saleOrgNo: joinTeamSourceNo, saleOrgType: joinTeamSourceType, activityId: joinTeamActivityId}}">进入星客联盟</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'join-team',
  data () {
    return {
      picUrl: {
        defaultImage: 'https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/cimen/share.png'
      },
      banner: '', // banner图
      teamName: '', // 战队名称
      inviterAvatar: '', // 邀请人头像
      inviterName: '', // 邀请人名字
      formData: { // 表单数据
        name: '', // 姓名
        mobile: '', // 手机号
        captcha: '' // 手机验证码
      },
      myStarTeamInfo: { // 个人信息及加入的战队信息
        avatar: '', // 我的头像
        joinTeamFlag: false, // 是否加入战队
        mobile: '', // 手机号
        nickName: '', // 昵称
        realName: '', // 真实姓名
        starFlag: false, // 是否是星客
        teamName: '' // 加入的战队名称
      },
      ticket: '', // 校验手机有没有发过短信的码
      sendLock: false, // 发送验证码锁定变量
      countDown: 60, // 倒计时
      isMobile: /^[1][0-9]{10}$/, // 手机号验证规则
      timeInter: '', // 定时器
      submitFlag: true
    }
  },
  computed: {
    joinTeamSourceNo () {
      return localStorage.getItem('joinTeamSourceNo')
    },
    joinTeamSourceType () {
      return localStorage.getItem('joinTeamSourceType')
    },
    joinTeamActivityId () {
      return localStorage.getItem('joinTeamActivityId')
    }
  },
  activated () {
    let self = this
    if (self.$route.query.sourceType) {
      localStorage.setItem('joinTeamSourceType', self.$route.query.sourceType)
    }
    if (self.$route.query.sourceNo) {
      localStorage.setItem('joinTeamSourceNo', self.$route.query.sourceNo)
    }
    if (self.$route.query.activityId) {
      localStorage.setItem('joinTeamActivityId', self.$route.query.activityId)
    }
    if (self.$route.query.clerkId && self.$route.query.clerkId !== '' && Number.isInteger(parseInt(self.$route.query.clerkId))) {
      localStorage.setItem('joinTeamClerkId', self.$route.query.clerkId)
    }
    if (self.$route.query.teamNo) {
      localStorage.setItem('joinTeamTeamNo', self.$route.query.teamNo)
    }
    if (self.$route.query.popularizeNo) {
      localStorage.setItem('joinTeamPopularizeNo', self.$route.query.popularizeNo)
    }
    this.queryTeamInfo()
    this.queryStarInfo()
    this.queryPopularizeInfo()
    this.queryStarTeamInfo()
  },
  methods: {
    queryTeamInfo () { // 查询战队信息
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/task/team/query/team/name',
          params: {
            teamNo: localStorage.getItem('joinTeamTeamNo')
          }
        })
        .then(res => {
          if (res.success) {
            self.teamName = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    queryStarInfo () { // 查询邀请人信息
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/query/info/by/source/no',
          params: {
            sourceType: localStorage.getItem('joinTeamSourceType'),
            sourceNo: localStorage.getItem('joinTeamSourceNo')
          }
        })
        .then(res => {
          if (res.success) {
            self.inviterAvatar = res.data.avatar // 邀请人头像
            self.inviterName = res.data.nickName // 邀请人名字
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    queryPopularizeInfo () { // 查询推广活动信息
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/my/join/activity',
          params: {
            popularizeNo: localStorage.getItem('joinTeamPopularizeNo')
          }
        })
        .then(res => {
          if (res.success) {
            if (res.data) {
              self.banner = res.data[0].popularizeImage
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    queryStarTeamInfo () { // 查询个人是否是星客且是否加入战队
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/query/star/team/info',
          params: {
            popularizeNo: localStorage.getItem('joinTeamPopularizeNo')
          }
        })
        .then(res => {
          if (res.success) {
            if (res.data) {
              self.myStarTeamInfo = res.data
              self.formData.name = self.myStarTeamInfo.realName ? self.myStarTeamInfo.realName : self.myStarTeamInfo.nickName
              self.formData.mobile = self.myStarTeamInfo.mobile ? self.myStarTeamInfo.mobile : ''
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    checkMsg () { // 检查手机号是否发送过短信
      let self = this
      if (!self.isMobile.test(self.formData.mobile)) {
        return self.$weui.toast('手机号格式不正确', {
          duration: 2000,
          className: 'toast_text'
        })
      }
      if (!self.sendLock) { // 如果是手机号并且发送按钮没有锁定
        self.sendLock = true // 锁定发送
        self.$fly
          .request({
            method: 'post',
            url: '/component/wechat/login/check/and/send/msg',
            params: {
              mobile: self.formData.mobile,
              ticket: self.ticket
            }
          })
          .then(res => {
            if (res.success) {
              self.ticket = ''
              self.countDownStart() // 发送验证码倒计时
            } else {
              self.sendLock = false // 解锁发送
              if (res.code === 20003) {
                self.ticket = res.data
                self.checkMsg() // 重新发送
              } else {
                self.$weui.toast(res.message, {
                  duration: 2000,
                  className: 'toast_text'
                })
              }
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    countDownStart () { // 开始倒计时
      let self = this
      self.countDown = 59
      clearInterval(self.timeInter)
      self.timeInter = setInterval(function () {
        if (self.countDown > 1) {
          self.countDown--
        } else {
          self.sendLock = false
          self.countDown = 60
          clearInterval(self.timeInter)
        }
      }, 1000)
    },
    joinTeam () { // 加入战队
      let self = this
      self.backTop() // 提交时将页面回到顶部
      if (!self.formData.name) {
        return self.$weui.toast('请输入您的姓名', {
          duration: 2000,
          className: 'toast_text'
        })
      }
      if (!self.formData.mobile) {
        return self.$weui.toast('请输入您的手机号', {
          duration: 2000,
          className: 'toast_text'
        })
      }
      if (!self.isMobile.test(self.formData.mobile)) {
        return self.$weui.toast('手机号格式不正确', {
          duration: 2000,
          className: 'toast_text'
        })
      }
      if (!self.myStarTeamInfo.mobile && !self.formData.captcha) {
        return self.$weui.toast('请输入验证码', {
          duration: 2000,
          className: 'toast_text'
        })
      }
      if (self.submitFlag) {
        self.submitFlag = false
        self.$fly
          .request({
            method: 'post',
            url: '/h5/star/task/team/join',
            body: {
              memberName: self.formData.name,
              mobile: self.formData.mobile,
              captcha: self.formData.captcha,
              clerkId: localStorage.getItem('joinTeamClerkId'),
              popularizeNo: localStorage.getItem('joinTeamPopularizeNo'),
              sourceNo: localStorage.getItem('joinTeamSourceNo'),
              sourceType: localStorage.getItem('joinTeamSourceType'),
              teamNo: localStorage.getItem('joinTeamTeamNo')
            }
          })
          .then(res => {
            self.submitFlag = true
            if (res.success) {
              self.$weui.alert('加入成功', {
                title: '提示',
                buttons: [{
                  label: '确定',
                  type: 'primary',
                  onClick: function () {
                    self.$router.push({
                      path: '/',
                      query: {
                        saleOrgType: localStorage.getItem('joinTeamSourceType'),
                        saleOrgNo: localStorage.getItem('joinTeamSourceNo'),
                        activityId: localStorage.getItem('joinTeamActivityId'),
                        clerkId: localStorage.getItem('joinTeamClerkId')
                      }
                    })
                  }
                }]
              })
            } else {
              self.$weui.alert(res.message, {
                title: '提示',
                buttons: [{
                  label: '确定',
                  type: 'primary'
                }]
              })
            }
          })
          .catch(err => {
            self.submitFlag = true
            console.log(err)
          })
      }
    },
    backTop () { // 输入框失去焦点时回到顶部
      console.log('backTop')
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style scoped lang="less">
.joinTeam{
  .inviter{
    text-align: center;
    padding: 20px 0;
    .photo{
      margin-bottom: 10px;
      img{
        width: 80px;
        height: 80px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
      }
    }
    .name{
      font-size: 26px;
    }
  }
  .joinTeamForm{
    padding: 20px;
    border: solid 1px #f0f0f0;
    background: #fff;
    .banner{
      position: relative;
      img{
        display: block;
        width: 100%;
      }
      .tip{
        display: block;
        width: 100%;
        height: 80px;
        line-height: 80px;
        position: absolute;
        left: 0;
        bottom: 0;
        color: #fff;
        text-align: center;
        background: rgba(0,0,0,0.5);
      }
    }
    .weui-vcode-btn{
      height: 48px;
      line-height: 48px;
    }
    .weui-form__opr-area{
      .btn-join{
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/team/joinTeam.vue